const size = {
  mobileS: '320px',
  mobileM: '400px',
  tablet: '600px',
  laptop: '1024px',
  laptopM: '1200px',
  laptopL: '1360px',
  desktop: '1440px',
  desktopL: '1920px',
  desktopXL: '1930px',
};

export const device = {
  mobileS: `(min-width: ${size.mobileS})`,
  mobileM: `(min-width: ${size.mobileM})`,
  tablet: `(min-width: ${size.tablet})`,
  laptop: `(min-width: ${size.laptop})`,
  laptopM: `(min-width: ${size.laptopM})`,
  laptopL: `(min-width: ${size.laptopL})`,
  desktop: `(min-width: ${size.desktop})`,
  desktopL: `(min-width: ${size.desktopL})`,
  desktopXL: `(min-width: ${size.desktopXL})`,
};
